<!-- Compact pill calling out a quarter-line (Asian handicap / quarter total)
     half result. Sits inline on the matchup line; the leg breakdown
     ("+0.5 won, 0 push") lives in the hover/click tooltip. Renders nothing
     when the bet isn't a half-win/half-loss. -->
<template>
  <Popper
    v-if="badge"
    hover
    arrow
    placement="top"
    :open-delay="100"
    class="half-badge-popper"
  >
    <span
      class="half-badge"
      :class="badge.win ? 'half-badge--win' : 'half-badge--loss'"
      role="button"
      tabindex="0"
      @click.stop
      @keydown.enter.stop
    >
      {{ badge.label }}
    </span>
    <template #content>
      {{ badge.detail }}
    </template>
  </Popper>
</template>

<script setup>
import { computed } from 'vue';
import Popper from 'vue3-popper';
import { getHalfLineBadge } from '@/core/utils';

const props = defineProps({
  session: {
    type: Object,
    required: true,
  },
});

const badge = computed(() => getHalfLineBadge(props.session));
</script>

<style scoped lang="scss">
@use '@/scss/theme/variables.scss' as theme;

.half-badge-popper {
  display: inline-flex;
  vertical-align: middle;
  margin-left: 0.4rem;

  /* The breakdown keeps its natural casing ("+0.5 won, 0 push") instead of
     inheriting an uppercase parent row. */
  :deep(.popper) {
    text-transform: none;
  }
}

.half-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: theme.$font-weight-bold;
  letter-spacing: 0.4px;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
  text-transform: none;

  &--win {
    background: #d1fae5;
    color: #065f46;
  }

  &--loss {
    background: #fee2e2;
    color: #991b1b;
  }

  &:focus-visible {
    outline: 2px solid theme.$blue-901;
    outline-offset: 1px;
  }
}
</style>
